export default __webpack_public_path__ + "static/media/error.8ccb9dec.svg";